import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {Button} from '@mui/material';
import {array, bool, func, number} from 'prop-types';

import FeatureCard from './FeatureCard.jsx';
import {ButtonBar} from '../ButtonBar.jsx';
import {Content} from '../Common.jsx';

const SimplifyStep = ({
  features: toSimplifyFeatures,
  onBack,
  onFinished,
  maxVertexes,
  importing,
}) => {
  const [currentFeature, setCurrentFeature] = useState(0);
  const [simplifiedFeatures, setSimplifiedFeatures] = useState([]);

  const geometryValidatorAbort = useRef(new AbortController());

  const doFinished = useCallback(() => {
    onFinished(
      simplifiedFeatures.map((simplified, idx) => {
        return {
          ...toSimplifyFeatures[idx],
          geometry: simplified.geometry,
          properties: {
            ...toSimplifyFeatures[idx].properties,
            pl_is_valid: true,
          },
        };
      }),
    );
  }, [onFinished, simplifiedFeatures, toSimplifyFeatures]);

  // reset the simplified features
  useEffect(() => {
    setSimplifiedFeatures(toSimplifyFeatures.map(() => null));
  }, [toSimplifyFeatures]);

  const isReady = useMemo(() => {
    return (
      simplifiedFeatures.filter(f => f !== null).length ===
      toSimplifyFeatures.length
    );
  }, [simplifiedFeatures, toSimplifyFeatures.length]);

  return (
    <>
      <Content>
        {toSimplifyFeatures.length > 0 && (
          <FeatureCard
            feature={toSimplifyFeatures[currentFeature]}
            selectedGeometry={simplifiedFeatures[currentFeature]}
            onChange={candidate => {
              // overwrite the object at the index.
              const nextGeometry = [...simplifiedFeatures];
              nextGeometry[currentFeature] = candidate;
              setSimplifiedFeatures(nextGeometry);
            }}
            currentFeature={currentFeature}
            setCurrentFeature={setCurrentFeature}
            nFeatures={toSimplifyFeatures.length}
            maxVertexes={maxVertexes}
          />
        )}
      </Content>
      <ButtonBar
        onBack={() => {
          geometryValidatorAbort.current.abort();
          onBack();
        }}
      >
        <Button
          disabled={!isReady || importing}
          variant="contained"
          color="primary"
          data-testid="simplify-btn"
          onClick={() => {
            doFinished();
          }}
        >
          {importing ? 'Importing...' : 'Import'}
        </Button>
      </ButtonBar>
    </>
  );
};

SimplifyStep.propTypes = {
  features: array,
  onFinished: func,
  onBack: func,
  maxVertexes: number,
  importing: bool,
};

export default SimplifyStep;
